// Vendor imports
const React = require('react')
// Browser-specific vendor imports
let Stickyfill
if (typeof window === 'object') {
  Stickyfill = require('stickyfill')()
}

function useStickyfill() {
  if (!Stickyfill) {
    return
  }
  const domRef = React.useRef(null)
  React.useEffect(() => {
    const el = domRef.current
    if (el) {
      el.classList.add('Stickyfill')
      Stickyfill.add(el)
      return () => {
        Stickyfill.remove(el)
        el.classList.remove('Stickyfill')
      }
    }
  })
  return domRef
}

module.exports = useStickyfill
